(ns quuppa.ui.button
  (:require [reagent.core :as r]
            [quuppa.ui.icons :refer [icon]]
            [quuppa.ui.util :as util]))

(defn button
"Render a button

[Bootstrap buttons](https://getbootstrap.com/docs/5.2/components/buttons/)

[Figma](https://www.figma.com/file/GiGKkEGjDMDirz5TMv6QSs/Bootstrap-5-Design-System?node-id=4%3A192632)"
  {:arglists '([& children]
               [props & children])}
  [& args]
  (let [[props children] (util/parse-args args)
        {:keys [variant outline active disabled on-click attr small large
                start-icon end-icon]
         :or {variant "primary"}} props]
    (assert (string? variant) (str ":variant must be string for " *ns* "/button"))
    (cond-> (into [:button.btn
                   (r/merge-props {:class (r/class-names
                                            [(str "btn-"
                                                  (when (and outline
                                                             (not= "link" variant))
                                                    "outline-")
                                                  variant)
                                             (when active
                                               "active")
                                             (when disabled
                                               "disabled")
                                             (when small
                                               "btn-sm")
                                             (when large
                                               "btn-lg")
                                             (when (or start-icon end-icon)
                                               "d-inline-flex flex-row justify-content-center")]
                                            (:class props))
                                   :on-click on-click}
                                  attr)
                   (when start-icon
                     (if (keyword? start-icon)
                       [icon start-icon {:class ["icon-md" (cond small "mr-1" large "mr-3" :else "mr-2")]}]
                       start-icon))]
                  children)
      end-icon (conj (if (keyword? end-icon)
                       [icon end-icon {:class ["icon-md" (cond small "ml-1" large "ml-3" :else "ml-2")]}]
                       [:span.ml-2.icon-md end-icon])))))


(defn close-button
  "[Close button](https://getbootstrap.com/docs/5.2/components/close-button/)"
  [props]
  [:button.btn-close
   (merge {:aria-label "Close"
           :title      "Close"}
          props)])

(defn stack
  "Stack of buttons aka [Block buttons](https://getbootstrap.com/docs/5.2/components/buttons/#block-buttons)"
  {:arglists '([& children]
               [props & children])}
  [& args]
  (let [[props children] (util/parse-args args)
        {:keys [class center cols]} props]
    (into [:div.d-grid.gap-2
           {:class (r/class-names [class
                                   (when cols
                                     (assert (integer? cols) "Columns width should be given as number")
                                     (str "col-" cols))
                                   (when center
                                     "mx-auto")])}]
          children)))
